export default {"src":"/_next/static/media/user_avatar.ba3432a6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};